<template>
<div>
	<div id="navbar-content">
		<b-navbar toggleable="lg" type="dark" class="nav-pantone-blue" >
			<div class="container-fluid">
				<b-navbar-brand href="/"><img src="@/assets/w_logo.png"  width="110" height="48"></b-navbar-brand>

				<b-navbar-brand href="/" v-if="isLogin" class="d-sm-block d-lg-none">
					<a href="/perfil" class="btn bg-transparent btn-sm text-white pointer">
						<i class="far fa-user-circle mr-2"></i>
						Mi Perfil
					</a>
				</b-navbar-brand>

				<b-navbar-toggle target="nav-collapse"/>

				<b-collapse id="nav-collapse" is-nav>
					<!--responsive menu - on screen minify -->
					<div class="menu-responsive d-lg-none d-md-block">
						<hr>
						<b-navbar-nav class="text-center" v-if="currentURL === null ">
							<b-nav-item href="/acerca-de" class="ml-2 font-weight-bold">Acerca de Kllaar</b-nav-item>
							<b-nav-item to="/empleos" class="ml-2" v-if="typeOrigin === 'student' || !isLogin"><i
								class="fas fa-briefcase"></i> Empleos
							</b-nav-item>
							<b-nav-item to="/cv" class="ml-2" v-if="typeOrigin === 'student' || !isLogin"><i
								class="far fa-user"></i> Mi CV
							</b-nav-item>
							<b-nav-item to="/cursos" class="ml-2" v-if="typeOrigin === 'student' || !isLogin"><i
								class="fas fa-graduation-cap"></i> Cursos
							</b-nav-item>
							<b-nav-item to="/empresas" class="ml-2" v-if="typeOrigin === 'student' || !isLogin"><i
								class="fas fa-building"></i> Empresas
							</b-nav-item>
						</b-navbar-nav> 
						<!-- <hr>
						<b-navbar-nav class="text-center">
							<b-nav-item to="/eres-empleador" class="ml-2" v-if="typeOrigin === 'enterprise' || (typeOrigin === '' || typeOrigin === null) ">
								 <span :style="$route.path == '/eres-empleador' ? 'color:#df9234;': ''">¿Eres Empleador?</span>
							</b-nav-item>
							<b-nav-item to="/eres-capacitador" class="ml-2" v-if="typeOrigin === 'trainer' || (typeOrigin === '' || typeOrigin === null) ">
								 <span :style="$route.path == '/eres-capacitador' ? 'color:#df9234;': ''">¿Eres capacitador?</span>
							</b-nav-item>
						</b-navbar-nav> -->
						<!-- <hr> -->
						<b-navbar-nav class="text-center" v-if="isLogin">
							<b-nav-item to="/perfil" class="ml-2 font-weight-bold">
								<i class="far fa-user-circle mr-2"></i>
								Mi Perfil
							</b-nav-item>
							<Notifications :notificationsList="notificationsList"/>
							<b-nav-item @click="logout" class="profile align-items-center ">
								<span class="font-weight-bold">
									<i class="fas fa-sign-in-alt"></i> Cerrar sesion
								</span>
							</b-nav-item>
						</b-navbar-nav>
						<b-navbar-nav class="text-center" v-else>
							<b-nav-item to="/login" class="ml-2">
								<i class="fas fa-user-circle"></i>
								Iniciar Sesión
							</b-nav-item>
							<b-nav-item to="/registrar" class="ml-2">Regístrate</b-nav-item>
						</b-navbar-nav>
						<hr>
						<b-navbar-brand class="d-flex justify-content-center pb-3">

							<a href="https://www.facebook.com/Kllaar/" target="_blank">
								<img src="@/assets/social/__ic_facebook.png" alt="" height="10" width="25" class="mx-2 pointer">
							</a>
							<a href="https://twitter.com/Kllaar_" target="_blank">
								<img src="@/assets/social/__ic_twitter.png" alt="" height="30" width="25" class="mx-2 pointer">
							</a>
							<a href="https://www.instagram.com/kllaar.com_oficial/" target="_blank">
								<img src="@/assets/social/__ic_instagram.png" alt="" height="30" width="25" class="mx-2 pointer">
							</a>
							<a href="https://www.youtube.com/channel/UCNufhwngZOWW0oE51Yo43Mw" target="_blank">
								<img src="@/assets/social/__ic_youtube.png" alt="" height="30" width="25" class="mx-2 pointer">
							</a>
							<a href="https://www.linkedin.com/company/kllaar" target="_blank">
								<img src="@/assets/social/__ic_linkedin.png" alt="" height="30" width="25" class="mx-2 pointer">
							</a>
						</b-navbar-brand>
						<hr>
						<b-navbar-nav class="text-center">
							<b-nav-item href="https://dev.kllaar.com/blog" target="_blank" class="py-3">
								<i class="fas fa-blog"></i>
								Blog Kllaar.com
							</b-nav-item>
						</b-navbar-nav>
					</div>

					<!--screen large -->
					<b-navbar-nav class="d-none d-lg-block">
						<b-nav-item href="/acerca-de" class="ml-2" v-if="!validationsSocial" :style="$route.path == '/acerca-de' ? 'background: #df9234; color:#fff;' : ''">
							<span :style="$route.path == '/acerca-de' ? 'color:#fff;': ''">Acerca de Kllaar</span>
						</b-nav-item>
					</b-navbar-nav>
					<b-navbar-nav class="ml-auto">
						<div class="menu-extends d-none d-lg-block">
							<!--on-login-->
							<div class="menu-section d-flex flex-row" v-if="isLogin">
								<b-nav-item to="/eres-empleador" class="ml-2" v-if="typeOrigin === 'enterprise'" :style="$route.path == '/eres-empleador' ? 'background: #df9234; color:#fff;' : ''">
									<span :style="$route.path == 'eres-empleador' ? 'color:#fff;': ''">¿Eres Empleador?</span>
								</b-nav-item>
								<b-nav-item to="/eres-capacitador" class="ml-2" v-if="typeOrigin === 'trainer'" :style="$route.path == '/eres-capacitador' ? 'background: #df9234; color:#fff;' : ''">
									<span :style="$route.path == '/eres-capacitador' ? 'color:#fff;': ''">¿Eres capacitador?</span>
								</b-nav-item>
								<Notifications :notificationsList="notificationsList"/>
								<b-nav-item to="/perfil" class="profile align-items-center ">
									<i class="fas fa-ellipsis-v mr-2"></i>
									<span class="text-white typeAccount font-weight-bold"><i
										class="far fa-user-circle mr-2"></i> Mi Perfil</span>
								</b-nav-item>
								<b-nav-item @click="logout" class="profile align-items-center ">
									<span class="text-white typeAccount font-weight-bold">
										<i class="fas fa-sign-in-alt"></i> Cerrar sesion
									</span>
								</b-nav-item>
							</div>
							<!--on-logout-->
							<div class="menu-section d-flex flex-row" v-else>
								<b-nav-item @click.prevent="rediretTo('/eres-empleador#pg1')" class="ml-2" v-if="!validationsSocial" :style="$route.path == '/eres-empleador' ? 'background: #df9234; color:#fff;' : ''">
									<span :style="$route.path == '/eres-empleador' ? 'color:#fff;': ''">¿Eres Empleador?</span>
								</b-nav-item>
								<b-nav-item @click="rediretTo('/eres-capacitador#pg7')"  class="ml-2" v-if="!validationsSocial" :style="$route.path == '/eres-capacitador' ? 'background: #df9234; color:#fff;' : ''">
									<span :style="$route.path == '/eres-capacitador' ? 'color:#fff;': ''">¿Eres capacitador?</span>
								</b-nav-item>
								<b-nav-item to="/login" class="ml-2" v-if="!validationsSocial">
									<i class="fas fa-user-circle"></i> Iniciar Sesión
								</b-nav-item>
								<b-nav-item to="/registrar" class="ml-2" v-if="!validationsSocial">
									Regístrate
								</b-nav-item>
							</div>
						</div>
					</b-navbar-nav>
				</b-collapse>     
			</div> 
			<div style="margin-left: 19vw; margin-top:2vw;" v-if="isMobile && $route.path != '/eres-empleador' && $route.path != '/eres-capacitador'">
				<button type="button" class="btn btn-sm b-orange font-blue align-center" @click="rediretTo('/eres-empleador#pg1')" style="box-shadow: 0 0 10px 5px #343a40;"> 
					¿Eres Empleador?
				</button> 
				<button type="button" class="btn btn-sm b-orange font-blue ml-2 align-center" @click="rediretTo('/eres-capacitador#pg7')" style="box-shadow: 0 0 10px 5px #343a40;"> 
						¿Eres Capacitador?
				</button>  
			</div>
			<div style="margin-left: 36vw; margin-top:2vw;" v-if="isMobile && $route.path == '/eres-empleador'">
				<button type="button" class="btn btn-sm b-orange font-blue align-center"   @click="visible = !visible" style="box-shadow: 0 0 10px 5px #343a40;"> 
					¿Eres Empleador?
				</button>
			</div>
			<div style="margin-left: 34vw; margin-top:2vw;" v-if="isMobile && $route.path == '/eres-capacitador'">
				<button type="button" class="btn btn-sm b-orange font-blue ml-2 align-center"   @click="visible2 = !visible2"  style="box-shadow: 0 0 10px 5px #343a40;"> 
						¿Eres Capacitador?
				</button>  
			</div>
		</b-navbar>
		<b-collapse id="collapse-1" class="mt-2" v-model="visible">
			<b-card> 
				<div  class="container-fluid" > 
					<b-list-group v-b-scrollspy:nav-scroller>
						<b-list-group-item href="#pg1"  @click="visible = false"><i class="far fa-folder mr-2"></i> ÚNETE</b-list-group-item>
						<b-list-group-item href="#pg2"  @click="visible = false"><i class="far fa-folder mr-2"></i> PUBLICA EMPLEOS</b-list-group-item>
						<b-list-group-item href="#pg3"  @click="visible = false"><i class="far fa-folder mr-2"></i> BUSCA CANDIDATOS</b-list-group-item>
						<b-list-group-item href="#pg4"  @click="visible = false"><i class="far fa-folder mr-2"></i> RANKING EMPRESAS</b-list-group-item>
						<b-list-group-item href="#pg5"  @click="visible = false"><i class="far fa-folder mr-2"></i> CONTRATA TU MEMBRESIA</b-list-group-item> 
						<b-list-group-item href="#pg66"  @click="visible = false"><i class="far fa-folder mr-2"></i> BLOG</b-list-group-item> 
						<!-- <a href="#pg1" class="nav-link mt-2" @click="visible = false">
							<span :style="$route.fullPath == '/eres-empleador#pg1' ? 'color:#df9234;': ''">
								<i class="far fa-folder mr-2"></i> Home
							</span>
						</a>  
						<a href="#pg2" class="nav-link mt-2" @click="visible = false">
							<span :style="$route.fullPath == '/eres-empleador#pg2' ? 'color:#df9234;': ''">
								<i class="far fa-folder mr-2"></i>	Publica empleos
							</span>
						</a> 
						<a href="#pg3" class="nav-link mt-2" @click="visible = false">
							<span :style="$route.fullPath == '/eres-empleador#pg3' ? 'color:#df9234;': ''">
								<i class="far fa-folder mr-2"></i> Busca candidatos
							</span>
						</a> 
						<a href="#pg4" class="nav-link mt-2" @click="visible = false">
							<span :style="$route.fullPath == '/eres-empleador#pg4' ? 'color:#df9234;': ''">
								<i class="far fa-folder mr-2"></i> Ranking empresas
							</span>
						</a> 
						<a href="#pg5" class="nav-link mt-2" @click="visible = false">
							<span :style="$route.fullPath == '/eres-empleador#pg5' ? 'color:#df9234;': ''">
								<i class="far fa-folder mr-2"></i> Contrata tu membresia
							</span>
						</a>  -->
					</b-list-group>
				</div>
			</b-card>
		</b-collapse>
		<b-collapse id="collapse-2" class="mt-2" v-model="visible2">
			<b-card> 
				<b-list-group v-b-scrollspy:nav-scroller2>
						<b-list-group-item href="#pg7"  @click="visible = false"><i class="far fa-folder mr-2"></i> HOME</b-list-group-item>
						<b-list-group-item href="#pg8"  @click="visible = false"><i class="far fa-folder mr-2"></i> MATCH</b-list-group-item>
						<b-list-group-item href="#pg9"  @click="visible = false"><i class="far fa-folder mr-2"></i> PUBLICAR CURSOS</b-list-group-item>
						<b-list-group-item href="#pg10"  @click="visible = false"><i class="far fa-folder mr-2"></i> CURSOS MÁS POPULARES</b-list-group-item> 
						<b-list-group-item href="#pg12"  @click="visible = false"><i class="far fa-folder mr-2"></i> BLOG</b-list-group-item> 
					</b-list-group> 
			</b-card>
		</b-collapse>

		<NavBarNavigation
			v-if="(typeOrigin === 'student' || !isLogin) && (!validationsSocial) && (currentURL===null)"/>
		<!-- <MenuCapacitador
			v-if="(!validationsSocial) && (currentURL==='capacitador')"/> -->
		<!-- <MenuEmpleador
			v-if="(!validationsSocial)  && (currentURL==='empleador')"/> -->
			<div class="d-none d-lg-block py-1" v-if="(!validationsSocial) && (currentURL==='capacitador')">
				<div class="container-fluid"> 
					<b-nav  class="d-flex justify-content-between" pills card-header slot="header" v-b-scrollspy:nav-scroller2 id="manuCambi">
						<b-nav-item href="#pg7"><span style="font-size:11px; font-weight: bold;">HOME</span></b-nav-item>
						<b-nav-item href="#pg8"><span style="font-size:11px; font-weight: bold;">MATCH</span></b-nav-item> 
						<b-nav-item href="#pg9"><span style="font-size:11px; font-weight: bold;">PUBLICAR CURSOS</span></b-nav-item>
						<b-nav-item href="#pg10"><span style="font-size:11px; font-weight: bold;">CURSOS POPULARES</span></b-nav-item> 
						<b-nav-item href="#pg12"><span style="font-size:11px; font-weight: bold;">BLOG</span></b-nav-item> 
					</b-nav>
				</div>
			</div> 


		  <div class="d-none d-lg-block py-1"  v-if="(!validationsSocial)  && (currentURL==='empleador')" id="empleadorzoom">
				<div class="container-fluid"> 
					<b-nav  class="d-flex justify-content-between" pills card-header slot="header" v-b-scrollspy:nav-scroller id="manuCambi">
						<b-nav-item href="#pg1"><span style="font-size:11px; font-weight: bold;">ÚNETE</span></b-nav-item>
						<b-nav-item href="#pg2"><span style="font-size:11px; font-weight: bold;">PUBLICA EMPLEOS</span></b-nav-item> 
						<b-nav-item href="#pg3"><span style="font-size:11px; font-weight: bold;">BUSCA CANDIDATOS</span></b-nav-item>
						<b-nav-item href="#pg4"><span style="font-size:11px; font-weight: bold;">RANKING EMPRESAS</span></b-nav-item> 
						<b-nav-item href="#pg5"><span style="font-size:11px; font-weight: bold;">CONTRATA MEMBRESIA</span></b-nav-item>
						<b-nav-item href="#pg66"><span style="font-size:11px; font-weight: bold;">BLOG</span></b-nav-item> 
					</b-nav>
				</div>
			</div> 


	
	</div>  
 
	<!-- <div  id="nav-scroller"   ref="content" style="position:relative; height:900px; overflow-y:scroll;"  v-if="(!validationsSocial)  && (currentURL==='empleador')">  
		<div id="pg1" class="container-fluid"><home :isLogin="isLogin"/></div>
		<div id="pg2" class="container-fluid"><publicar :isLogin="isLogin"/></div>
		<div id="pg3" class="container-fluid"><busca-candidatos :isLogin="isLogin"/></div>
		<div id="pg4" class="container-fluid"><ranking :isLogin="isLogin"/></div>
		<div id="pg5" class="container-fluid"><membresia  :isLogin="isLogin"/></div>
		<div id="pg66" class="container-fluid"><blog :isLogin="isLogin"/></div>		
	</div> -->

	 
	<!-- <div  id="nav-scroller2"   ref="content" style="position:relative; height:900px; overflow-y:scroll;"   v-if="(!validationsSocial) && (currentURL==='capacitador')">  
		<div id="pg7" class="container-fluid"><homeCapa :isLogin="isLogin"/></div>
		<div id="pg8" class="container-fluid"><publicarcursosuno :isLogin="isLogin"/></div>
		<div id="pg9" class="container-fluid"><publicarcursos :isLogin="isLogin"/></div>
		<div id="pg10" class="container-fluid"><cursospopulares :isLogin="isLogin"/></div> 
		<div id="pg11" class="container-fluid"><blogCapa :isLogin="isLogin"/></div>		
	</div> -->
</div>
</template>
<!--navbarStyles-->
<style lang="scss" >
#navbar-content {
	z-index: 10000000;
	position: fixed;
	top: 0;
	width: 100vw;
	background-color: #ffffff;

	.router-link-exact-active {
		background: transparent !important;
		color: #FFF;
		font-weight: bold;
		border-left: 0 !important;
		border-bottom: 0 !important;
		box-shadow: none !important;
	}
}   

#manuCambi .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #df9234;
} 

</style>
<!--menuStyles-->
<style  lang="scss">
@media screen and (min-width: 500px) {
	#navbar-content .container-fluid {
		width: 90vw;
		padding-right: 20px;
		padding-left: 20px;
		// zoom: 90%;
	}
}
</style>
<script>
import NavBarNavigation from './TheTopNavBarOptions'
import Notifications from './notificaciones/TheTopNotifications'
import MenuCapacitador from './landing/menu_capacitador'
import MenuEmpleador from './landing/menu_empleador'


import home from '../views/landing/empleador/home'
import publicar from '../views/landing/empleador/publicar'
import buscacandidatos from '../views/landing/empleador/busca-candidatos'
import ranking from '../views/landing/empleador/ranking'
import membresia from '../views/landing/empleador/membresia'
import blog from '../views/landing/empleador/blog' 

import homeCapa from '../views/landing/capacitador/home'
import publicarcursosuno from '../views/landing/capacitador/publicar-cursos-uno'
import publicarcursos from '../views/landing/capacitador/publicar-cursos'
import cursospopulares from '../views/landing/capacitador/cursos-populares'
import blogCapa from '../views/landing/capacitador/blog'
export default {
	components: {
		'NavBarNavigation': NavBarNavigation,
		'Notifications': Notifications,
		'MenuCapacitador': MenuCapacitador,
		'MenuEmpleador': MenuEmpleador,
		'home': home,
		'publicar': publicar,
		'busca-candidatos': buscacandidatos,
		'ranking':ranking,
		'membresia':membresia,
		'blog':blog,
		'homeCapa':homeCapa,
		'publicarcursosuno':publicarcursosuno,
		'publicarcursos':publicarcursos,
		'cursospopulares':cursospopulares,
		'blogCapa':blogCapa,
	},
	data() {
		return {
			notificationsList: [],
			activar_menu: null,
			isMobile: this.$mobile(),
			visible:false,
			visible2:false
		}
	},
	methods: {
		logout() {
			this.$store.dispatch('logout')
				.then(() => {
					this.$router.push('/login')
				})
		},
		rediretTo(url){
			window.location.href = url
		}

	},
	computed: {
		avatar: function () {
			return this.$store.getters.avatar
		},
		type: function () {
			return this.$store.getters.type
		},
		typeOrigin: function () {
			return this.$store.getters.typeOrigin
		},
		isLogin: function () {
			return this.$store.getters.isLoggedIn
		},
		active: function () {
			return this.$store.getters.active
		},
		validationsSocial() {
			return this.$store.getters.getValidationSocial
		},
		currentURL() {

			let empleador = [
				'/eres-empleador',
				'/eres-empleador#pg1',
				'/eres-empleador#pg2',
				'/eres-empleador#pg3',
				'/eres-empleador#pg4',
				'/eres-empleador#pg5',
				'/eres-empleador#pg66'
			]

			let exist_empleador = empleador.find((i) => {
				return i === this.$route.fullPath
			})

			let capacitador = [
				'/eres-capacitador',
				'/eres-capacitador#pg7',
				'/eres-capacitador#pg8',
				'/eres-capacitador#pg9',
				'/eres-capacitador#pg10',
				'/eres-capacitador#pg11',
				'/eres-capacitador#pg12'
			]

			let exist_capacitador = capacitador.find((i) => {
				return i === this.$route.fullPath
			})


			if (exist_empleador) {
				this.activar_menu = 'empleador'
			} else if (exist_capacitador) {
				this.activar_menu = 'capacitador'
			} else {
				this.activar_menu = null
			}
			return this.activar_menu

		}
	},
	created() {
		this.bus.$on('notify', value => {
			this.notificationsList = value
		})
	},
	// mounted(){
	// 	var height  = $(window).width(); 
	// 		console.log(height);
	// 		if (height < 1580 && !this.isMobile)
	// 		{ 
	// 			const elem3 = document.getElementById("manuCambi");
	// 			elem3.style.zoom='80%';  
	// 		}
	// }
}
</script>



// WEBPACK FOOTER //
// src/components/TheTopNavBar.vue